import React, { useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";
import { ASSETS } from "@/lib/assets";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password reset. Log in with your new password.");
      navigate("/login");
    } catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
    finally { setLoading(false); }
  };

  if (!token) return (
    <div className="max-w-md mx-auto px-4 py-16 text-center">
      <h1 className="headline text-cream text-2xl">Invalid reset link.</h1>
      <Link to="/forgot-password" className="btn-neon mt-6 inline-flex">Request A New One</Link>
    </div>
  );

  return (
    <div className="max-w-md mx-auto px-4 sm:px-6 py-16 text-center">
      <img src={ASSETS.pointing} alt="" className="w-28 mx-auto" />
      <h1 className="headline text-cream text-3xl mt-3">SET A NEW <span className="text-neon">PASSWORD</span></h1>
      <form onSubmit={submit} className="comic-card p-6 mt-8 space-y-4">
        <input type="password" required placeholder="New password (min 6 chars)" value={password} onChange={(e) => setPassword(e.target.value)}
          className="w-full bg-ink border-3 border-black px-3 py-2.5 font-mono text-sm text-cream focus:outline-none focus:border-neon" data-testid="reset-password" />
        <button disabled={loading || password.length < 6} className="btn-neon w-full disabled:opacity-50" data-testid="reset-submit">{loading ? "..." : "Reset Password"}</button>
      </form>
    </div>
  );
}
